<template>
  <b-modal v-model="showImageBank" class="image-bank-image" ref="imageBankModal" size="lg" hide-footer>

    <template #title>
      <div class="w-100" style="display: flex; align-items: center;">
        <h5 style="margin-bottom: 0px;">{{ $t('privatePage.imageBank') }}</h5>
      </div>
    </template>

    <b-form @submit="onSubmit">
      <div v-for="folder in folderStructure.folders" :key="folder.fullPath">
        <b-card no-body class="mb-1" style="border: none; margin-bottom: 0.5rem;">
          <b-card-header style="padding: 0px; border: none;">
            <span v-if="folder.isNew">
              <b-form-input v-model="folder.name"></b-form-input>
              <b-button type="submit">{{ $t('save') }}</b-button>
            </span>
            <b-button v-else block href="#" v-b-toggle="'upperAccordion' + folder.name" variant="primary" style="text-align: left; color: #fff; padding: 15px; width: 100%;">
                {{ folder.name }}
            </b-button>
          </b-card-header>
          <b-collapse :id="'upperAccordion' + folder.name" role="tabpanel">
            <b-card>
              <div v-for="subFolder in folder.folders" :key="subFolder.fullPath">
                <b-row style="margin-bottom: 0.5rem">
                  <b-col>
                    <span v-if="subFolder.isNew">
                      <b-form-input v-model="subFolder.name"></b-form-input>
                      <b-button type="submit">{{ $t('save') }}</b-button>
                    </span>
                    <b-button v-else block href="#" v-b-toggle="'subAccordion' + subFolder.name" variant="success" style="text-align: left; padding: 15px; width: 100%;">
                      {{ subFolder.name }}
                    </b-button>
                    <b-collapse :id="'subAccordion' + subFolder.name" role="tabpanel">
                      <b-card>
                        <span v-for="image in subFolder.images" :key="image.fullPath">
                          <b-button variant="outline-success" style="margin: 10px;">
                            <b-img :src="image.fullPath" @click.stop="onImageSelected(image)"/>
                          </b-button>
                        </span>

                        <b-row style="margin-top: 1rem;">
                          <input type="file"
                            :value="file.name || ''"
                            class="ms-2 me-2"
                            :placeholder="$t('privatePage.imageBankAddImage')"
                            accept="image/png/svg"
                            @change="e => onFileUploaded(e, subFolder)"
                            v-show="!subFolder.isNew"
                          />
                        </b-row>
                      </b-card>
                    </b-collapse>
                  </b-col>
                </b-row>
              </div>

              <b-button ref="addFolderButton"
                        style="margin-top: 1rem;"
                        @click.stop="onAddFolder(folder)"
                        v-show="!folder.isNew">
                        {{ $t('privatePage.imageBankAddFolder') }}
              </b-button>
            </b-card>
          </b-collapse>
        </b-card>
      </div>

      <template #footer>
        <div class="w-100">
          <b-button class="pull-left"
                variant="primary"
                style="margin-right: 5px;"
                @click.stop="onAddFolder(folderStructure)">
                {{ $t('privatePage.imageBankAddFolder') }}
          </b-button>
          <b-button class="pull-right" variant="danger" @click="hideBank">{{ $t('cancel') }}</b-button>
        </div>
      </template>
    </b-form>
  </b-modal>

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'image-bank',
  data() {
    return {
      file: {},
      newFolder: {},
      showImageBank: false
    }
  },

  computed: {
    ...mapGetters('imageBankModule', ['folderStructure']),
    fields() {
      return [
        {
          key: 'name',
          label: 'Folder'
        },
        {
          key: 'show_details',
          label: ' '
        }
      ]
    }
  },
  methods: {
    ...mapActions('imageBankModule', {
      getFolderStructure: 'getFolderStructure',
      uploadImage: 'uploadImage',
      addFolder: 'addFolder'
    }),
    showBank: function() {
      this.showImageBank = true
    },
    hideBank: function() {
      this.showImageBank = false
    },
    onImageSelected: function(image) {
      this.$emit('onImageSelected', image)
      this.hideBank()
    },
    onFileUploaded: function(e, subFolder) {
      const files = e.target.files
      if (!files.length) return
      const selectedFile = files[0]
      this.file = selectedFile

      let fData = new FormData()
      fData.append('file', selectedFile)
      fData.append('folderPath', subFolder.fullPath)

      this.uploadImage(fData).then(image => {
        this.onImageSelected(image)
        this.getFolderStructure()
      })
    },
    onAddFolder: function(folder) {
      let newFolder = {
        fullPath: folder.fullPath ? folder.fullPath : '/',
        name: '',
        folders: [],
        images: [],
        isNew: true
      }
      folder.folders.push(newFolder)
      this.newFolder = newFolder
    },
    onSubmit(evt) {
      evt.preventDefault()
      this.addFolder(this.newFolder).then(result => {
        this.newFolder.fullPath = result.fullPath
        this.newFolder.isNew = false
      })
    }
  },
  created() {
    this.getFolderStructure()
  }
}
</script>

<style scoped>
.modalButton {
  width: 100%;
  margin: 15px 0px 15px 0px;
}

.rowMarginal {
  margin-bottom: 0.5em;
}
</style>
